// Lightweight device classifier for presence heartbeat payloads.
// No external dependencies; keep it deterministic in both browsers and SSR guards.

const MOBILE_RE = /Mobi|Android|iPhone|iPod|Phone/i;
const TABLET_RE = /Tablet|iPad|Nexus 7|Nexus 9|SM-T|Kindle|Silk/i;

export function getDeviceInfo() {
  if (typeof navigator === 'undefined') {
    return {
      deviceType: 'unknown',
      deviceId: 'web',
      userAgent: 'unknown',
      platform: 'unknown',
      vendor: 'unknown',
    };
  }

  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const vendor = navigator.vendor || '';

  const isTablet = TABLET_RE.test(ua);
  const isMobile = !isTablet && MOBILE_RE.test(ua);

  let deviceType = 'desktop';
  if (isTablet) deviceType = 'tablet';
  else if (isMobile) deviceType = 'mobile';

  return {
    deviceType,
    deviceId: 'web',
    userAgent: ua,
    platform,
    vendor,
  };
}

export default getDeviceInfo;
